import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100vh',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      height:580
    },
    [theme.breakpoints.down('sm')]: {
      height:450
    }
  },
  videoContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: -1
  },
  headerText: {
    color: 'white',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%'
  },
  h1: {
    fontSize: 50,
    maxWidth: 860,
    textShadow: '3px 1px 6px #000',
    textAlign: 'center',
    lineHeight: 1.3,
    fontFamily: 'Roboto Slab',
    marginTop: '2em',
    [theme.breakpoints.down('md')]: {
      marginTop:0,
      padding: 10
    },
    [theme.breakpoints.down('sm')]: {
      fontSize:30
    },
    [theme.breakpoints.down('xs')]: {
      fontSize:25
    }
  },
  video: {
    width: '100%',
    position: 'fixed',
    [theme.breakpoints.down('sm')]: {
      width:'120%'
    },
    [theme.breakpoints.down('xs')]: {
      width:'200%',
      marginLeft: -50
    }
  },
  li: {
    listStyleType: 'none',
    fontSize: 20,
    width: 320,
    textAlign: 'center',
    background: 'rgba(0,0,0,.6)',
    padding: 20,
    margin: 10,
    cursor: 'pointer',
    fontFamily: 'Roboto Slab',
    '&:hover': {
      background: 'rgba(2, 127, 128, 0.77)'
    }
  },
  ul: {
    display: 'flex'
  },
  bajada: {
    maxWidth: 800,
    textAlign: 'center',
    fontSize: 20,
    textShadow: '2px 2px 4px #000',
    fontWeight: 'bolder',
    [theme.breakpoints.down('md')]: {
      padding: 20
    },
    [theme.breakpoints.down('xs')]: {
      fontSize:15
    }
  },
  legend: {
    padding: 5,
    fontSize: 14,
    textAlign: 'right',
    color: '#fff',
    textShadow: '1px 1px 2px #000',
    [theme.breakpoints.down('sm')]: {
      marginTop:-70
    }
  }
}))

const Header = ({ bajada, title, image, legend }) => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <div className={classes.videoContainer}>
          <img
            src={image}
            alt={title}
            className={classes.video}
          />
        </div>
        <div className={classes.headerText}>
          <h1 className={classes.h1}>
            {title}
          </h1>
          <div className={classes.bajada}>
            {bajada}
          </div>
        </div>
      </div>
      <div className={classes.legend}>{legend}</div>
    </>
  )
}

Header.propTypes = {
  bajada: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  legend: PropTypes.string
}

export default Header
